import { createStore } from 'vuex';

export default createStore({
  state: {
    hostname: 'www.german-films.de',
    site: '/festivals/search-festival-guide',
    extensionName: 'tx_snmoviefestivaldb',
    pluginName: 'moviefestivaldb',
    type: '2753189518',
    selectedFestivalCard: 0,
    allGenres: [],
    allCategories: [],
    counter: 0,
    idForSearchRequest: [],
    wholeDatabase: [],
    sortCriteria: 'title,asc',
    searchURL: '',
    fetchError: 0,
    completedLoading: false,
    vueURL: '',
    festivalTypes: [],
    countries: [],
    texts: [],
  },
  mutations: {
    updateSite(state, data) {
      this.state.site = data;
    },
    updateVueURL(state, data) {
      this.state.vueURL = data;
    },
    updateURL(state, URL) {
      // eslint-disable-next-line no-param-reassign
      state.searchURL = URL;
    },
    updateSelectedFestivalCard(state, id) {
      // eslint-disable-next-line no-param-reassign
      state.selectedFestivalCard = id;
    },
    updateAllGenres(state, data) {
      this.state.allGenres = data;
    },
    updateAllCategories(state, data) {
      this.state.allCategories = data;
    },
    updateIdForSearchRequest(state, data) {
      console.log(data);
      this.state.idForSearchRequest = data;
    },
    updateCounter(state, data) {
      this.state.counter += data;
      if (data === 0) {
        this.state.counter = 0;
      }
    },
    updateWholeDatabase(state, data) {
      /* eslint-disable no-param-reassign */
      data.forEach((film) => {
        state.wholeDatabase.push(film);
      });
    },
    updateSortCriteria(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.sortCriteria = data;
    },
    clearEntries(state) {
      // eslint-disable-next-line no-param-reassign
      state.wholeDatabase = [];
    },
    updateError(state, error) {
      // eslint-disable-next-line no-param-reassign
      state.fetchError = error;
    },
    completeLoading(state, a) {
      // eslint-disable-next-line no-param-reassign
      state.completedLoading = a;
    },
    updateFestivalTypes(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.festivalTypes = data;
    },
    updateCoutries(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.countries = data;
    },

    updateTexts(state, data) {
      state.texts = data;
    },
  },
  getters: {
    getSelectedFestival(state) {
      return state.wholeDatabase.filter((Film) => Film.uid === state.selectedFestivalCard)[0];
    },
  },
});
